import React from 'react'
import { Link } from 'react-router-dom'
import CauseImage from '../../components/cause'

export default function Causes(props) {
    return (
        <div>
            <section className="causes-section ptb-200">
            <div className="container">
                <div className="section-title">
                    <span>
                        <i className="flaticon-ribbon"></i>
                        Our Causes
                    </span>
                    <h2>The causes we care about</h2>
                    <p>Child Hope holds a few key causes close at heart. Some of them include;</p>
                </div>

                <div className="row">
                    <div className="col-lg-4 col-md-6">
                        <div className="single-causes">
                            {/* <img src="assets/img/causes/1.jpg" alt="image"/> */}
                            <CauseImage image="assets/img/causes/1.jpg" title="Education for poor child"/>
                            <div className="icon">
                                <i className="flaticon-book-1"></i>
                            </div>

                            <div className="causes-content">
                                <span>#Education</span>
                                <h3>Education for poor child</h3>
                                <p>Education is essential in a child’s life and lays the foundation of his/her adulthood success later in life. Child Hope therefore strives to ensure that the children under it’s care obtain  education.</p>

                                <div className="causes-progress-bar">
                                    <div className="causes-progress-content">
                                        <span>Raised: $5,000.00</span>
                                        
                                        <div className="text-right">
                                            <span>Goal: $8,000.00</span>
                                        </div>
                                    </div>
                                    <p>Raised by 60 people within 10 days</p>
                                </div>
                                
                                <a href="single-causes.html" className="causes-btn-one">
                                    Donate Now
                                    <i className="flaticon-right"></i>
                                </a>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6">
                        <div className="single-causes">
                            <CauseImage image="assets/img/causes/2.jpg" title="Philanthropy"/>
                            <div className="icon">
                                <i className="flaticon-laptop"></i>
                            </div>

                            <div className="causes-content">
                                <span>#Philanthropy</span>
                                <h3>Massive donation to poor</h3>
                                <p>While we strive to fulfill our promise to offer at-risk children a better life through education and welfare, we rely heavily on donations made to our cause by the general public.</p>

                                <div className="causes-progress-bar">
                                    <div className="causes-progress-content">
                                        <span>Raised: $4,000.00</span>
                                        
                                        <div className="text-right">
                                            <span>Goal: $8,000.00</span>
                                        </div>
                                    </div>
                                    <p>Raised by 40 people within 12 days</p>
                                </div>
                                
                                <Link to="/causes/oiuhehvgv" className="causes-btn-one">
                                    Donate Now
                                    <i className="flaticon-right"></i>
                                </Link>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6">
                        <div className="single-causes">
                        <CauseImage image="assets/img/causes/3.jpg" title="Shelter"/>

                            <div className="icon">
                                <i className="flaticon-blood-bag"></i>
                            </div>

                            <div className="causes-content">
                                <span>#Shelter</span>
                                <h3>Home for the homeless</h3>
                                <p>For children that are homeless we provide a safe and caring environment to live in and protection from harm. This organization will be a home for orphans and refugees children and a center for the provision of their basic needs.</p>

                                <div className="causes-progress-bar">
                                    <div className="causes-progress-content">
                                        <span>Raised: $1,000.00</span>
                                        
                                        <div className="text-right">
                                            <span>Goal: $5,000.00</span>
                                        </div>
                                    </div>
                                    <p>Raised by 50people within 20days</p>
                                </div>
                                
                                <Link to="/causes/oiuhehvgv" className="causes-btn-one">
                                    Donate Now
                                    <i className="flaticon-right"></i>
                                </Link>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6">
                        <div className="single-causes">
                            <CauseImage image="assets/img/causes/4.jpg" title="Health Care"/>

                            <div className="icon">
                                <i className="flaticon-book-1"></i>
                            </div>

                            <div className="causes-content">
                                <span>#Health Care</span>
                                <h3>Health care service</h3>
                                <p>Orphans and refugees are often prone to ill-health. Suitable health care services are provided at the facility to help treat, record and follow-up on the illness detected. The doctors make recommendations for further treatment if necessary.</p>

                                <div className="causes-progress-bar">
                                    <div className="causes-progress-content">
                                        <span>Raised: $5,000.00</span>
                                        
                                        <div className="text-right">
                                            <span>Goal: $8,000.00</span>
                                        </div>
                                    </div>
                                    <p>Raised by 60 people within 10 days</p>
                                </div>
                                
                                <Link to="/causes/oiuhehvgv"className="causes-btn-one">
                                    Donate Now
                                    <i className="flaticon-right"></i>
                                </Link>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6">
                        <div className="single-causes">
                            <CauseImage image="assets/img/causes/5.jpg" title="Counseling Sessions"/>

                            <div className="icon">
                                <i className="flaticon-laptop"></i>
                            </div>

                            <div className="causes-content">
                                <span>#Counseling Sessions</span>
                                <h3>Mental Health Recovery</h3>
                                <p>The emotional well-being of the children is vital to learning. Qualified counselors will be sought to restore, rebuild and inspire them to an uplifting future. This is to ensure that they leave the trauma from their past behind and start forward afresh.</p>

                                <div className="causes-progress-bar">
                                    <div className="causes-progress-content">
                                        <span>Raised: $4,000.00</span>
                                        
                                        <div className="text-right">
                                            <span>Goal: $8,000.00</span>
                                        </div>
                                    </div>
                                    <p>Raised by 40 people within 12 days</p>
                                </div>
                                
                                <Link to="/causes/oiuhehvgv" className="causes-btn-one">
                                    Donate Now
                                    <i className="flaticon-right"></i>
                                </Link>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6">
                        <div className="single-causes">
                            <CauseImage image="assets/img/causes/6.jpg" title="Feeding"/>
                            <div className="icon">
                                <i className="flaticon-blood-bag"></i>
                            </div>

                            <div className="causes-content">
                                <span>#Feeding</span>
                                <h3>Eradicate malnutrition</h3>
                                <p>We are on a quest to eradicate malnutrition. A tangible feeding program is needed for the children that live at the facility. Three meals are provided daily in accordance to the national food guide.</p>

                                <div className="causes-progress-bar">
                                    <div className="causes-progress-content">
                                        <span>Raised: $1,000.00</span>
                                        
                                        <div className="text-right">
                                            <span>Goal: $5,000.00</span>
                                        </div>
                                    </div>
                                    <p>Raised by 50people within 20days</p>
                                </div>
                                
                                <Link to="/causes/oiuhehvgv" className="causes-btn-one">
                                    Donate Now
                                    <i className="flaticon-right"></i>
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                        <div className="single-causes">
                            <CauseImage image="assets/img/causes/3.jpg" title="Spirituality"/>

                            <div className="icon">
                                <i className="flaticon-blood-bag"></i>
                            </div>

                            <div className="causes-content">
                                <span>#Spirituality</span>
                                <h3>Encouraging religion and the love of God </h3>
                                <p>The children sheltered by this organization come from shaky backgrounds, and teaching them to have faith provides them with a sense of stability which we hope will provide a source of strength as they grow up.</p>

                                <div className="causes-progress-bar">
                                    <div className="causes-progress-content">
                                        <span>Raised: $1,000.00</span>
                                        
                                        <div className="text-right">
                                            <span>Goal: $5,000.00</span>
                                        </div>
                                    </div>
                                    <p>Raised by 50people within 20days</p>
                                </div>
                                
                                <Link to="/causes/oiuhehvgv" className="causes-btn-one">
                                    Donate Now
                                    <i className="flaticon-right"></i>
                                </Link>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6">
                        <div className="single-causes">
                            <CauseImage image="assets/img/causes/1.jpg" title="Protection"/>

                            <div className="icon">
                                <i className="flaticon-blood-bag"></i>
                            </div>

                            <div className="causes-content">
                                <span>#Protection</span>
                                <h3>Keeping the children away from danger</h3>
                                <p>By keeping these children in school, we ensure that they are kept busy doing something productive which is likely to change the course of their lives for the better.</p>

                                <div className="causes-progress-bar">
                                    <div className="causes-progress-content">
                                        <span>Raised: $1,000.00</span>
                                        
                                        <div className="text-right">
                                            <span>Goal: $5,000.00</span>
                                        </div>
                                    </div>
                                    <p>Raised by 50people within 20days</p>
                                </div>
                                
                                <Link to="/causes/oiuhehvgv" className="causes-btn-one">
                                    Donate Now
                                    <i className="flaticon-right"></i>
                                </Link>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6">
                        <div className="single-causes">
                            <CauseImage image="assets/img/causes/4.jpg" title="Advocacy"/>

                            <div className="icon">
                                <i className="flaticon-blood-bag"></i>
                            </div>

                            <div className="causes-content">
                                <span>#Advocacy</span>
                                <h3>Ensuring Children’s Rights are fulfilled</h3>
                                <p>Child Hope believes that every child deserves a future. This belief is at the heart of everything we do, and we strive to ensure that all children under our care have every one of their human rights met and then some!
</p>

                                <div className="causes-progress-bar">
                                    <div className="causes-progress-content">
                                        <span>Raised: $1,000.00</span>
                                        
                                        <div className="text-right">
                                            <span>Goal: $5,000.00</span>
                                        </div>
                                    </div>
                                    <p>Raised by 50people within 20days</p>
                                </div>
                                
                                <Link to="/causes/oiuhehvgv" className="causes-btn-one">
                                    Donate Now
                                    <i className="flaticon-right"></i>
                                </Link>
                            </div>
                        </div>
                    </div>

 
                    <div className="col-lg-12 col-md-12">
                        <div className="pagination-area">
                            <a href="#" className="prev page-numbers">
                                <i className="flaticon-left"></i>
                            </a>
                            <a href="#" className="page-numbers">1</a>
                            <span className="page-numbers current" aria-current="page">2</span>
                            <a href="#" className="page-numbers">3</a>
                            <a href="#" className="page-numbers">4</a>
                            <a href="#" className="next page-numbers">
                                <i className="flaticon-right"></i>
                            </a>
                        </div>
                    </div>
                </div> 
            </div>
        </section>
            
        </div>
    )
}
